import {textDecoration} from '@chakra-ui/react'
import {pxToRem} from '../../../../utills/pxToRem'

export const overlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background:
        'radial-gradient(ellipse closest-corner at 50% 50%, rgba(0, 0, 0, 1) 1%, rgba(0, 0, 0, 0.75) 100%)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

export const closeButton = {
    color: 'white',
    position: 'absolute',
    top: [pxToRem(10)],
    right: [pxToRem(30)],
    height: pxToRem(16),
    minWidth: pxToRem(16)
}

export const overlayDesc = {
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    width: pxToRem(350),
    textAlign: 'center'
}

export const overlayDescText = {
    color: 'white',
    fontSize: pxToRem(15),
    paddingTop: pxToRem(10),
    paddingBottom: pxToRem(10),
    lineHeight: pxToRem(20.25),
    margin: 0,
    fontWeight: 600,
    letterSpacing: 0
}

export const continueButton = {
    color: 'white',
    fontSize: pxToRem(15),
    textDecoration: 'underline',
    paddingTop: pxToRem(10),
    paddingBottom: pxToRem(10),
    lineHeight: pxToRem(20.25),
    fontWeight: 700
}
